export const siteSettings = {
  name: "Trade Velocity Pro",
  link: "https://tradesvelocitypro.live",
  email: "support@tradesvelocitypro.live",
  appLink: "https://app.tradesvelocitypro.live",
};
